<template>
  <div>
    <template v-if="$store.state.adminUser || $store.state.isSuperAdmin">
      <navigation-top/>

      <div class="admin-container">
        <div class="admin-sidebar">
          <v-card class="pl-2 pr-2 h-100">
            <v-list>
              <v-list-subheader>Admin</v-list-subheader>
              <v-list-item v-if="$store.state.isSuperAdmin"
                           class="cursor-pointer" color="var(--blue-4)" rounded="md"
                           :active="$route.path === '/admin'"
                           @click="$router.push('/admin')">
                <v-list-item-title>Organizations</v-list-item-title>
              </v-list-item>
              <!-- Registered Users / Subscriptions / Enterprise / Settings are
                   Continuum Design SaaS features gated on the legacy Admin group.
                   SuperAdmin-only users see only the Organizations tab. -->
              <template v-if="$store.state.adminUser">
                <v-list-item class="cursor-pointer" color="var(--blue-4)" rounded="md"
                             :active="$route.matched?.[$route.matched.length - 1]?.path === '/admin'"
                             @click="$router.push('/admin')">
                  <v-list-item-title>Registered Users</v-list-item-title>
                </v-list-item>
                <v-list-item class="cursor-pointer" color="var(--blue-4)" rounded="md"
                             :active="$route.matched?.[$route.matched.length - 1]?.path === '/admin/subscriptions'"
                             @click="$router.push('/admin/subscriptions')">
                  <v-list-item-title>Subscriptions</v-list-item-title>
                </v-list-item>
                <v-list-item class="cursor-pointer" color="var(--blue-4)" rounded="md"
                             :active="$route.matched?.[$route.matched.length - 1]?.path === '/admin/enterprise-customers'"
                             @click="$router.push('/admin/enterprise-customers')">
                  <v-list-item-title>Enterprise Customers</v-list-item-title>
                </v-list-item>
                <v-list-item class="cursor-pointer" color="var(--blue-4)" rounded="md"
                             :active="$route.matched?.[$route.matched.length - 1]?.path === '/admin/settings'"
                             @click="$router.push('/admin/settings')">
                  <v-list-item-title>Settings</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </div>
        <div class="admin-content-container">
          <div class="admin-content">
            <router-view/>
          </div>
        </div>
      </div>
    </template>
    <v-card v-else>
      <v-card-title>Not authorized for this page.</v-card-title>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavigationTop from '@/components/NavigationTop.vue'

export default {
  components: { NavigationTop },
  computed: {
    ...mapState({
      currentUser: state => state.user.user,
      activeSubscription: state => state.payments.activeSubscription,
      loadingActiveSubscription: state => state.payments.loadingActiveSubscription
    })
  },
  data () {
    return {
      drawer: true,
      rail: true
    }
  },
  async mounted () {
  }
}
</script>

<style scoped>
.admin-container {
  gap: 16px;
  display: flex;
  margin-left: -16px;
  padding-bottom: 32px;
  width: calc(100% + 32px);
  min-height: calc(100vh - 110px);
}

.admin-sidebar {
  width: 200px;
}

.admin-content-container {
  width: calc(100% - 200px);

}

.admin-content {
}
</style>
